import React from 'react'
import { Box, Flex } from 'grid-styled'
// import Hide from 'styles/utilities/Hide'
import { withRouter } from 'react-router-dom'

// import DropdownList, { ListItem as DropListItem } from 'app/modules/IdentifiersList/DropdownList'
// import DotButton from 'app/elements/DotButton'
// import Checkbox from 'app/elements/Checkbox'

// import PlusIcon from 'app/elements/Icon/ic-plus'
import { ListItem, LineTextContainer, LineText } from './styles'

const IdentifierListItem = ({
  checkboxValues,
  vehicle,
  itemDropdownId,
  history,
  isItemDropdownOpen,
  handleSelectItem,
  handleItemDropdown,
  handleItemDropdownClose,
  handleCreateInf,
  itemStatus
}) => {
  const { veiculo, situacao, codIdentificador } = vehicle
  const active = situacao === 'ATIVO'
  const carPlate = veiculo.placa
  const identifierId = codIdentificador
  // const carCategory = veiculo.categoria
  // const carType = veiculo.tipo === 'CAMINHAO' ? 'Caminhão' : veiculo.tipo
  // const sortedInfos = sortedInformations(informacoesGerenciais)
  // const isChecked = !!checkboxValues.find(item => item.idIdentificador === idIdentificador)
  // const renderIndexInfoManage = tipo =>
  //   tipo === 'INFORMACAO_1' ? 1 : tipo === 'INFORMACAO_2' ? 2 : 3

  // function sortedInformations(informations) {
  //   return informations == null
  //     ? null
  //     : informations.sort((a, b) => {
  //         return a.tipoInfo.toLowerCase() < b.tipoInfo.toLowerCase() ? -1 : 1
  //       })
  // }

  return (
    <ListItem blocked={!!active}>
      <Flex width={1} direction={['row', 'row']}>
        {/* <Box width={[1 / 12, 0.5 / 12]}>
          <LineTextContainer>
            <Checkbox checked={isChecked} onChange={handleSelectItem(vehicle)} />
          </LineTextContainer>
        </Box> */}
        {/* <Box width={[3 / 12, 2 / 12]}>
          <LineTextContainer>
            <LineText capitalize bold>
              {carType.toLowerCase()}
            </LineText>
          </LineTextContainer>
        </Box> */}
        <Box width={[4 / 12, 2 / 12]}>
          <LineTextContainer>
            <LineText>{carPlate}</LineText>
          </LineTextContainer>
        </Box>
        {/* <Hide at="small" width={[1, 2 / 12]}>
          <LineTextContainer>
            <LineText>{carCategory}</LineText>
          </LineTextContainer>
        </Hide> */}
        <Box width={[5 / 12, 2 / 12]}>
          <LineTextContainer>
            <LineText>{identifierId}</LineText>
          </LineTextContainer>
        </Box>
        <Box width={[3 / 12, 2 / 12]}>
          <LineTextContainer>
            <LineText>{situacao}</LineText>
          </LineTextContainer>
        </Box>
        {/* <Box width={[3 / 12, 3 / 12]}>
          <ChipContainer>
            {!sortedInfos || sortedInfos.length === 0 ? (
              <ChipEmpty onClick={() => handleCreateInf(vehicle)}>
                <PlusIcon /> Add Informação
              </ChipEmpty>
            ) : (
              sortedInfos.map((item, i) => (
                <Chip key={i}>
                  {renderIndexInfoManage(item.tipoInfo)}. {item.descricaoAtual}
                </Chip>
              ))
            )}
          </ChipContainer>
        </Box> */}
        {/* <Box width={[1, 0.5 / 12]}>
          <LineTextContainer>
            <DotButton onClick={handleItemDropdown(idIdentificador)} />
            <DropdownList
              secondary
              isOpen={isItemDropdownOpen && itemDropdownId === idIdentificador}
              onClose={handleItemDropdown()}
            >
              {itemStatus !== 'INATIVO' && (
                <DropListItem
                  onClick={() => history.push(`identificador/${identifierId}/bloquear`)}
                >
                  Bloquear / Substituir
                </DropListItem>
              )}
              <DropListItem onClick={() => history.push(`identificador/${identifierId}/alterar`)}>
                Gerenciar informações
              </DropListItem>
            </DropdownList>
          </LineTextContainer>
        </Box> */}
      </Flex>
    </ListItem>
  )
}

IdentifierListItem.defaultProps = {
  checkboxValues: [],
  vehicle: {},
  handleSelectItem: () => {},
  itemDropdownId: 0,
  isItemDropdownOpen: false,
  handleItemDropdown: () => {},
  handleItemDropdownClose: () => {},
  handleCreateInf: () => {}
}

export default withRouter(IdentifierListItem)



// WEBPACK FOOTER //
// ./src/app/elements/IdentifiersListItemForPartners/index.js